import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#060709]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 flex flex-col sm:flex-row items-center justify-between gap-6">
      <div className="flex items-center gap-3">
        <img src="/logo.png" alt="Personal and Team Coach" className="h-10 w-10 rounded-lg object-cover ring-1 ring-white/10" />
        <span className="text-xs text-slate-500">Mental Coaching Sportivo · Settori Giovanili</span>
      </div>
      <div className="flex items-center gap-6 text-sm text-slate-400">
        <a href="#prenota" className="hover:text-sky-400 transition-colors">Prenota</a>
        <a href="#prima-sessione" className="hover:text-sky-400 transition-colors">Sessione Gratuita</a>
        <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-sky-400 transition-colors">Privacy Policy</Link>
        <Link to="/admin" data-testid="footer-admin-link" className="flex items-center gap-1.5 hover:text-sky-400 transition-colors">
          <Lock className="w-3.5 h-3.5" /> Area Riservata
        </Link>
      </div>
      <p className="text-xs text-slate-600">© 2026 Personal &amp; Team Coach. Tutti i diritti riservati.</p>
    </div>
  </footer>
);
